import {
  InterviewState,
  InterviewInterface,
  useInterviewStore,
} from "state/interview";

const isStartedSelector = (state: InterviewInterface) =>
  state.interviewState === InterviewState.Started;
export const useIsStarted = () => useInterviewStore(isStartedSelector);
